import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DigiLockerCallback = () => {
  const location = useLocation();

useEffect(() => {
  const params = new URLSearchParams(location.search);

  // DigiLocker logout has completed and redirected back
  // if (params.get("error") === "user_loggedout") {
  //   window.close();
  //   return;
  // }
  if (params.get("error") === "user_loggedout") {
  if (window.opener) {
    window.opener.postMessage(
      {
        type: "DIGILOCKER_LOGOUT_COMPLETE",
      },
      window.location.origin
    );
  }

  window.close();
  return;
}

  const payload = {
    status: params.get("status"),
    pageNo: params.get("pageNo"),
    succeeded: params.get("succeeded"),
    errorMessage: params.get("errorMessage"),
    docCode: params.get("docCode"),
  };

  if (window.opener) {
    console.log("OPENER EXISTS");

    window.opener.postMessage(
      {
        type: "DIGILOCKER_CALLBACK",
        payload,
      }
    );

    // Logout DigiLocker in the SAME window/session
    const logoutUrl =
      "https://digilocker.meripehchaan.gov.in/signin/logout/Y";

    window.location.href = logoutUrl;

    // Keep your existing close attempt
    setTimeout(() => {
      window.close();
    }, 1000);
  }
}, [location]);

  return <h3>Processing DigiLocker response...</h3>;
};

export default DigiLockerCallback;